import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { customerInsuranceDetail, insuranceContent } from './../request.js';
import { quillEditor } from 'vue-quill-editor';
import copywritingModel from '@/views/insurance/insuranceManage/mainFrom/copywritingModel.vue';
import quillConfig from '@/views/components/editor/quill-config.js';
import { uploadFile } from './../../../customer/applicationManage/request';
import { cryptoDecrypt } from '@/utils/aes';
import { recursionCopy } from '@/views/customer/roleManage/utils';
import { getBase64 } from '@/utils/validate';
export default {
  components: {
    quillEditor,
    copywritingModel
  },
  props: {
    customerInsuranceId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      uploadFile,
      quillOption: quillConfig,
      dataForm: {
        claimsProcess: '',
        copywriting: []
      },
      loading: false,
      copywritingShow: false,
      previewVisible: false,
      previewImage: '',
      fileList: [],
      saveLoading: false
    };
  },
  computed: {
    dataRule() {
      return {
        feature: [{
          required: false,
          max: 40,
          message: this.$t('最多输入') + '40' + this.$t('字符'),
          trigger: 'blur'
        }]
      };
    }
  },
  created() {
    customerInsuranceDetail({
      customerInsuranceId: this.customerInsuranceId
    }).then(res => {
      this.dataForm = {
        customerInsuranceId: this.customerInsuranceId,
        feature: res.feature && res.feature.name || '',
        claimsProcess: res.claimsProcess,
        copywriting: res.copywriting,
        coverUrl: res.coverUrl
      };
      if (res.coverUrl) {
        this.fileList = [{
          url: res.coverUrl,
          uid: 1,
          name: '222',
          status: 'done'
        }];
      }
    });
  },
  mounted() {
    this.$refs.myTextEditor.quill.enable(false);
    setTimeout(() => {
      this.$refs.myTextEditor.quill.enable(true);
    }, 1000);
  },
  methods: {
    addCopywritingFun() {
      this.copywritingShow = true;
      this.$nextTick(() => {
        this.$refs.copywritingFrom.init();
      });
    },
    copywritingHandleOk(val) {
      this.dataForm.copywriting.push({
        index: 0,
        name: val,
        content: '',
        isEdit: true
      });
      this.copywritingShow = false;
    },
    beforeUpload(file) {
      const isJpgOrPng = file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'image/jpeg';
      if (!isJpgOrPng) {
        this.$message.error(this.$t('请上传正确的图片格式,例如:jpg,png,jpeg'));
        return false;
      }
      const isLt5k = file.size / 1024 < 500;
      if (!isLt5k) {
        this.$message.error(this.$t('上传图片应小于500kb'));
      }
      return isJpgOrPng && isLt5k;
    },
    handleChange(info) {
      if (info.fileList.length == 0) {
        this.dataForm.coverUrl = '';
        this.fileList = [];
      } else {
        this.fileList = info.fileList;
        if (info.file.status === 'uploading') {
          this.loading = true;
          return;
        }
        if (info.file.status === 'done') {
          let infoObj = process.env.NODE_ENV === 'production' ? cryptoDecrypt(info.file.response.data) : info.file.response.data;
          this.dataForm.coverUrl = infoObj.fileTempUrl;
          this.loading = false;
        } else {
          this.fileList = [];
        }
      }
    },
    async nextFun() {
      let parameters = recursionCopy(this.dataForm);
      if (parameters.copywriting.length != 0) {
        const arr = parameters.copywriting.filter(item => !item.content);
        if (arr.length != 0) {
          return this.$message.error(arr[0].name + this.$t('文案的内容,必须要填写'));
        }
        parameters.copywriting.map((item, index) => {
          item.index = Number(index + 1);
          return item;
        });
        parameters.copywriting = JSON.stringify(parameters.copywriting);
      } else {
        parameters.copywriting = '';
      }
      this.saveLoading = true;
      await insuranceContent(parameters);
      this.$message.success(this.$t('操作成功') + '!');
      this.saveLoading = false;
      this.$emit('next', {});
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    }
  }
};